import { combineReducers } from '@reduxjs/toolkit';
import { trainingsListReducer } from '../pages/TrainingsList/redux';

export const rootReducer = combineReducers({
  trainingsList: trainingsListReducer,
});
